import { ModifierCode } from '@/queries/program_purses/schemas'
import NonGradeModifierCard from './NonGradeModifierCard'

interface ExtraModifierCardsProps {
  modifiers: Array<{
    code: ModifierCode
    modifierName: string
    isActive: boolean
  }>
  onConfigureModifier: (code: ModifierCode) => void
}

export function ExtraModifierCards({
  modifiers,
  onConfigureModifier,
}: ExtraModifierCardsProps) {
  return (
    <>
      {modifiers.map(({ code, modifierName, isActive }) => (
        <NonGradeModifierCard
          key={code}
          modifierName={modifierName}
          isActive={isActive}
          onConfigure={() => onConfigureModifier(code)}
        />
      ))}
    </>
  )
}
